<app-header></app-header>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><a href="/echipa">Echipa</a></li>
                <li>Informatii Medic</li>
            </ul>
            <h2>Informatii Medic</h2>
        </div>
    </div>
</div>

<div class="instructor-details-area pt-70 pb-70">
    <div class="container">
        <div class="instructor-details-desc">
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <div class="instructor-details-sidebar">
                        <div *ngIf="doctor.photo"><img [src]="setFilePath(doctor)" alt="test"></div>
                        <div *ngIf="!doctor.photo"><img src="../../../assets/img/medici/no-image.jpg" alt="image"></div>
<!--                        <img src="assets/img/instructor/instructor1.jpg" alt="image">-->
                    </div>
                </div>
                <div class="col-lg-8 col-md-8">
                    <div class="instructor-details">
                        <h3>{{doctor.name}}</h3>
                        <span class="sub-title">Medic {{doctor.professionalDegree}}</span>
                        <p>{{doctor.description}}</p>


<!--                        <div class="instructor-details-info">
                            <div class="row">
                                <div class="col-lg-6 col-md-12">
                                    <h3>My Education</h3>
                                    <ul>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span>Harvard University</span>
                                            Bachelor in Mathematics
                                        </li>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span>University of Toronto</span>
                                            Bachelor in English
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-6 col-md-12">
                                    <h3>My Experience</h3>
                                    <ul>
                                        <li>
                                            <i class='bx bx-briefcase'></i>
                                            <span>Envato</span>
                                            2000-2010
                                        </li>
                                        <li>
                                            <i class='bx bx-briefcase'></i>
                                            <span>EnvyTheme</span>
                                            2010-2020
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>-->


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
